module.exports = __webpack_public_path__ + "img/ic_roll.3362573a.svg";